import Collapse from "@material-ui/core/Collapse";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import React, { FC } from "react";

import classes from "../AdGroupCreationForm.module.scss";
import { CreativeAssetFromFile } from "../../../../../../types/campaignTypes";
import { InvalidDroppedFile } from "../types";
import { truncateText } from "../../../../../../helpers/truncateText";

type LoaadedAssetProps = {
  creativeAsset: CreativeAssetFromFile | InvalidDroppedFile;
  isAssetShown: boolean;
  handleHideAsset: () => void;
  handleShowAsset: () => void;
  handleRemoveAsset?: () => void;
  invalid?: boolean;
};

const LoaadedAsset: FC<LoaadedAssetProps> = ({
  creativeAsset,
  isAssetShown,
  handleHideAsset,
  handleShowAsset,
  handleRemoveAsset,
  invalid,
}) => {
  return (
    <>
      <div className={`${classes.uploadedFile} ${invalid ? classes.invalid : ""}`}>
        <Typography>{truncateText(creativeAsset.file.name, 48)}</Typography>
        <div className={classes.uploadedFileControls}>
          {isAssetShown ? (
            <IconButton onClick={handleHideAsset}>
              <VisibilityOffIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton onClick={handleShowAsset}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
          )}

          {invalid ? null : (
            <IconButton onClick={handleRemoveAsset}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>

      <Collapse in={isAssetShown} className={classes.collapse}>
        {creativeAsset.fileType === "image" ? (
          <img src={URL.createObjectURL(creativeAsset.file)} alt={creativeAsset.file.name} />
        ) : (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video controls>
            <source src={URL.createObjectURL(creativeAsset.file)} type="video/mp4" />
          </video>
        )}
        <Typography className={classes.imgSizeNote}>
          Note: The width and height are not real. However, the proportions are respected.
        </Typography>
      </Collapse>
    </>
  );
};

export default LoaadedAsset;
